import classNames from 'classnames'
import { mobileAppDownloadPath, newRegistryPath, wtaProviders } from 'lib/urls'
import Link from 'components/link'
import Image from 'components/image'
import { InfoButton, LinkButton } from 'components/buttons'
import { useScrollDirection } from 'lib/hooks'
import { useTracking, track, withContextualizedTracking } from 'lib/analytics'
import css from './styles.scss'

const MicroUtilityBar = () => {
  const tracker = useTracking()

  const scrollDirection = useScrollDirection()

  const handleLoginClick = () => {
    tracker.trackEvent({
      event: track.navbarClicked,
      eventLocation: track.EventLocation.MOBILE_WEB_TOP_UTILITY_BAR,
      eventCta: 'Login',
    })
    PubSub.publish('authModal.show')
  }

  const handleSignUpClick = () => {
    tracker.trackEvent({
      event: track.signUpStarted,
    })
    tracker.trackEvent({
      event: track.navbarClicked,
      eventLocation: track.EventLocation.MOBILE_WEB_TOP_UTILITY_BAR,
      eventCta: 'Sign Up',
    })
    window.location.href = newRegistryPath
  }

  const handleAppDownloadClick = () => {
    tracker.trackEvent({
      event: track.navbarClicked,
      eventLocation: track.EventLocation.MOBILE_WEB_TOP_UTILITY_BAR,
      eventCta: 'App Download',
    })
  }

  const rootClassName = classNames(css.root, {
    [css.pinned]: scrollDirection === 'down',
  })

  return (
    <div className={rootClassName}>
      <div className={css.left}>
        <Link
          className={css.link}
          url={mobileAppDownloadPath(null, wtaProviders.APPSFLYER)}
          onClick={handleAppDownloadClick}
        >
          Get the Babylist app{' '}
          <Image
            role="presentation"
            src="//images.babylist.com/image/upload/v1683910170/App_arrow_bjfs7b.svg"
          />
        </Link>
      </div>
      <div className={css.right}>
        <LinkButton className={css.link} onClick={handleLoginClick}>
          Log in
        </LinkButton>
        <InfoButton
          pill
          className={css.signUpButton}
          onClick={handleSignUpClick}
        >
          Sign up{' '}
          <Image
            role="presentation"
            src="//images.babylist.com/image/upload/v1683907821/heart_c2cuig.svg"
          />
        </InfoButton>
      </div>
    </div>
  )
}

export default withContextualizedTracking({
  eventLocation: track.EventLocation.MOBILE_WEB_TOP_UTILITY_BAR,
})(MicroUtilityBar)
